import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { PipeSpecUploadMenu } from './PipeSpecUpload';
import { ServiceGroupUploadMenu } from './ServiceGroupUpload';

export const DataFixingUploadsButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [sgAnchorEl, setSgAnchorEl] = useState<null | HTMLElement>(null);
  const [psAnchorEl, setPsAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id="import-files-button"
        startIcon={
          <AbyssIcon
            iconName="file-upload-secondary"
            style={{ height: '1.6rem', width: '1.6rem' }}
          />
        }
        endIcon={<ArrowDropDownIcon sx={{ fontSize: '1.6rem !important' }} />}
        variant="outlined"
        onClick={handleClick}
        size="small"
      >
        Import Files
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{
          width: '100%',
          '> *': { width: '10%' },
        }}
      >
        <MenuItem onClick={() => setPsAnchorEl(anchorEl)}>
          <ListItemText>Pipe Spec</ListItemText>
          <ChevronRightIcon />
        </MenuItem>

        <MenuItem onClick={() => setSgAnchorEl(anchorEl)}>
          <ListItemText>Service Group</ListItemText>
          <ChevronRightIcon />
        </MenuItem>
      </Menu>
      <ServiceGroupUploadMenu anchorEl={sgAnchorEl} setAnchorEl={setSgAnchorEl} />
      <PipeSpecUploadMenu anchorEl={psAnchorEl} setAnchorEl={setPsAnchorEl} />
    </>
  );
};
